import React, { Component } from "react";
import FlexView from "react-flexview";
import { connect } from "react-redux";
import ErrorAction from "../../../Redux/ErrorRedux";
import Api from "../../../Services/Api";
import { fetchDataAsync } from "../../../Services/Utils";
import SimpleDataTable from "../../../modules/SimpleDataTable";
import ButtonAction from "../../../modules/commons/ButtonAction";
import Container from "../../../modules/commons/Container";
import SimpleButton from "../../../modules/commons/SimpleButton";
import SimpleLoadingOverlay from "../../../modules/popup/SimpleLoadingOverlay";
import { ACTIVITY_TYPE, HttpStatus } from "../../common/Constants";
import MasterAcuanStockDetail from "./components/masterAcuanStockDetail";
import { tableConfig } from "./config";
import { defaultTableChange } from "../../../modules/custom/customTable";
class MasterAcuanStock extends Component {
  tableColumn = [
    ...tableConfig,
    {
      name: "id",
      label: "Aksi",
      options: {
        sort: false,
        setCellProps: () => ({
          style: { width: "25%" },
        }),
        customBodyRender: (val, { rowIndex }) => {
          const { menuAccess } = this.props;
          return (
            <FlexView vAlignContent="center" style={{ gap: "12px" }}>
              <ButtonAction
                iconName="fa-eye"
                onClick={() =>
                  this.handleDetailVisibility(ACTIVITY_TYPE.VIEW, val)
                }
              />
              <ButtonAction
                iconName="fa-pencil-alt"
                disabled={!menuAccess?.updateAccess}
                onClick={() =>
                  this.handleDetailVisibility(ACTIVITY_TYPE.UPDATE, val)
                }
              />
              <ButtonAction
                iconName="fa-copy"
                disabled={!menuAccess?.createAccess}
                onClick={() =>
                  this.handleDetailVisibility(ACTIVITY_TYPE.COPY, val)
                }
              />
              <ButtonAction
                iconName="fa-trash"
                disabled={!menuAccess?.deleteAccess}
                onClick={() =>
                  this.handleDetailVisibility(ACTIVITY_TYPE.DELETE, val)
                }
              />
            </FlexView>
          );
        },
      },
    },
  ];

  constructor(props) {
    super(props);
    this.state = {
      dataTable: [],
      pagination: {
        limit: 5,
        page: 1,
        totalData: 0,
      },
      detailVisible: false,
      loading: false,
      activityType: null,
      selectedId: null,
      skipNextFetch: false,
    };
  }

  componentDidMount() {
    this.fetchDataTable(
      this.state.pagination.limit,
      this.state.pagination.page
    );
  }

  componentDidUpdate(prevProps, prevState) {
    const curr = this.state;
    if (
      (prevState.pagination.limit !== curr.pagination.limit ||
        prevState.pagination.page !== curr.pagination.page) &&
      !curr.skipNextFetch
    ) {
      this.fetchDataTable(curr.pagination.limit, curr.pagination.page);
    }
    if (curr.skipNextFetch) {
      this.setState({ skipNextFetch: false });
    }
  }

  fetchDataTable = async (limit, page) => {
    this.handleTriggerLoading();
    const res = await fetchDataAsync({
      asyncFn: Api.create("NAGAMAS_MASTER_DATA").getMasterAcuanStock,
      menuName: "Master Acuan Stock",
      setError: this.props.setError,
      args: {
        limit: limit,
        page: page,
      },
    });
    this.handleTriggerLoading();
    if (res.ok && res.data.status === HttpStatus.SUCCESS) {
      this.setState((prev) => ({
        ...prev,
        dataTable: res.data.data,
        pagination: {
          ...prev.pagination,
          totalData: res.data.totalData,
        },
      }));
    }
  };

  handleTriggerLoading = () => {
    this.setState((prev) => ({ ...prev, loading: !prev.loading }));
  };

  handleDetailVisibility = (activityType, id) => {
    this.setState((prev) => ({
      ...prev,
      detailVisible: !prev.detailVisible,
      activityType: activityType,
      selectedId: id,
    }));
  };

  handleRefreshPagination = () => {
    this.setState({
      pagination: {
        limit: 5,
        page: 1,
        totalData: 0,
      },
      skipNextFetch: true,
    });
    this.fetchDataTable(5, 1);
  };

  handleChangePage = (tableState) => {
    const limit = tableState.rowsPerPage;
    const page = tableState.page + 1;
    this.setState((prevValue) => ({
      ...prevValue,
      pagination: {
        ...prevValue.pagination,
        page: page,
        limit: limit,
      },
    }));
  };

  handleChangeRowsPerPage = (tableState) => {
    const limit = tableState.rowsPerPage;
    this.setState((prevValue) => ({
      ...prevValue,
      pagination: {
        ...prevValue.pagination,
        totalData: 0,
        page: 1,
        limit: limit,
      },
    }));
  };

  render() {
    const { dataTable, pagination, loading, detailVisible, activityType } =
      this.state;
    return (
      <Container>
        <SimpleDataTable
          data={dataTable}
          toCount={pagination.totalData}
          rowsPerPage={pagination.limit}
          page={pagination.page - 1}
          columns={this.tableColumn}
          options={defaultTableChange(
            this.handleChangePage,
            this.handleChangeRowsPerPage
          )}
          footerAdditionalButtons={
            <SimpleButton
              text="Tambah"
              disabled={!this.props.menuAccess?.createAccess}
              secondary={!this.props.menuAccess?.createAccess}
              onClick={() => this.handleDetailVisibility(ACTIVITY_TYPE.CREATE)}
              icon={<i className="fa fa-plus margin margin-right-5px" />}
            />
          }
        />
        {detailVisible && (
          <MasterAcuanStockDetail
            {...this.props}
            selectedId={this.state.selectedId}
            visible={detailVisible}
            handleTriggerLoading={this.handleTriggerLoading}
            onClickClose={this.handleDetailVisibility}
            onRefresh={this.handleRefreshPagination}
            activityType={activityType}
          />
        )}
        {loading && <SimpleLoadingOverlay active={loading} />}
      </Container>
    );
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    setError: (payload) => dispatch(ErrorAction.setError(payload)),
  };
};

export default connect(null, mapDispatchToProps)(MasterAcuanStock);
